module.exports = __webpack_public_path__ + "img/Graduated.03c2c148.svg";